export default __webpack_public_path__ + "static/media/Flag_of_Bangladesh.b90eb817.svg";